import React from "react";
import {
	RESULT_FIELDS,
	DATA_TYPE_FIELD,
	DECISION_TYPE_FIELD,
	FILING_TYPE_FIELD,
	SERVICE_DATE_FIELD,
	OFFICIAL_FILING_DATE_FIELD,
	DOCKET_TITLE_FIELD,
	DECIDING_BODY_FIELD,
	FILED_FOR_FIELD,
	FILING_ATTACHMENT_FIELD,
	FILING_DATE_FIELD,
	DECISION_ATTACHMENT_FIELD
} from "../../../resources/constants/fields";
import {
	DECISIONS_SEARCH_FOR_OPTION,
	FILINGS_SEARCH_FOR_OPTION,
	DECISION_DATA_TYPE,
	FILING_DATA_TYPE,
} from "../../../resources/constants/searches";
import { ATTACHMENTS_LABEL } from "../../../resources/constants/ui";
import { getLocalStringDate } from "../../../resources/util/dateUtil";
import { getDocketNumFromDataEntry, getFilenameFromUrl } from "../components/SearchResults";

class RecentsList extends React.Component {
	constructor(props) {
		super(props);

		var fields = null;
		if (props.searchFor === DECISIONS_SEARCH_FOR_OPTION) {
			fields = this.getResultFields(RESULT_FIELDS[DECISION_DATA_TYPE]);
		} else if (props.searchFor === FILINGS_SEARCH_FOR_OPTION) {
			fields = this.getResultFields(RESULT_FIELDS[FILING_DATA_TYPE]);
		}

		this.state = {
			searchFor: props.searchFor,
			fields: fields,
			data: props.data
		};

		this.getRows = this.getRows.bind(this);
	}

	getResultFields = function(fields) {
		var dataFields = {
			type: "",
			date: "",
			description: "",
			attachment: ""
		};
		fields.forEach(field => {
			switch (field) {
				case DATA_TYPE_FIELD:
					dataFields.type = field;
					break;
				case DECISION_TYPE_FIELD:
					dataFields.name = field;
					break;
				case FILING_TYPE_FIELD:
					dataFields.name = field;
					break;
				case SERVICE_DATE_FIELD:
					dataFields.date = field;
					break;
				case FILING_DATE_FIELD:
					dataFields.date = field;
					break;
				case OFFICIAL_FILING_DATE_FIELD:
					dataFields.date = field;
					break;
				case DOCKET_TITLE_FIELD:
					dataFields.title = field;
					break;
				case DECIDING_BODY_FIELD:
					dataFields.description = field;
					break;
				case FILED_FOR_FIELD:
					dataFields.description = field;
					break;
				case FILING_ATTACHMENT_FIELD:
					dataFields.attachment = field;
					break;
				case DECISION_ATTACHMENT_FIELD:
					dataFields.attachment = field;
					break;
				default:
					break;
			}
		});
		return dataFields;
	};

	getRows = function() {
		if (this.state.data.dataSubset) {
			var items = this.state.data.dataSubset;
			return items.map((row, index) => {
				let isLateClass = "";/*getIsLateClass(row[LATE_RELEASE_FIELD]);*/
				return (
					<div key={index} className={"recents"}>
						<p className={"notes-link " + isLateClass}>
							{row[this.state.fields.name]} -{" "}
							{getDocketNumFromDataEntry(row)}
						</p>
						<p className={"small-date " + isLateClass}>
							{getLocalStringDate(row[this.state.fields.date])}
						</p>
						<p className={"notes-description " + isLateClass}>
							{row[this.state.fields.title]}
						</p>
						<p className={"notes-attachment " + isLateClass}>
							{ATTACHMENTS_LABEL}{" "}
							{row[this.state.fields.attachment] ? (
								<a
									href={row[this.state.fields.attachment]}
									title={row[this.state.fields.attachment]}
									target="_blank"
									rel="noopener noreferrer"
								>
									{getFilenameFromUrl(row[this.state.fields.attachment])}
								</a>
							) : (
								<span>None</span>
							)}
						</p>
					</div>
				);
			});
		}
	};

	render() {
		return <div>{this.getRows()}</div>;
	}
}

export default RecentsList;
